/* eslint-disable */
import axios from "axios";
import store from "../../store/index";
import customModal from "../customModal/customModal.vue";
import showformmodel from "../showformmodel/showformmodel.vue"
import manageVisitModal from "../manageVisitModal/manageVisitModal.vue";
import VisitActivityModal from "../VisitActivityOrder/VisitActivityOrder.vue"

export default {
    name: "VisitActivityTree",
    props: {
        visitData: {
            type: Object,
            required: true
        },
        version: {
            type: String,
            required: false
        }
    },
    components: {
        customModal,
        showformmodel,
        manageVisitModal,
        VisitActivityModal
    },
    data() {
        return {
            baseapi: process.env.VUE_APP_Service_URL,
            token: store.getters.getIdToken,
            head: {},
            studyId: "",
            visitList: [],
            activityList: [],
            activityObj: {},
            openedVisitArray: [],
            formList: [],
            setshowActivityFormModal: false,
            showVisitPopup: [false],
            formActivityId: "",
            loading: false,
            selectedArm: "",
            armList: [],
            showVisitPopup: [],
            rollsprivilages: store.getters.getUserPrivilagesList,
            showSiteModal: false,
            visitId: null,
            showActivityModal: false,
            SelectedVisitId: null,
            selectedVersion: this.version || "",
            visitExpanded: [],
            title: "",
            baseurl: process.env.VUE_APP_Service_URL,
            isArmSpecific: false,
            studyDetails: {},
            versiondetailsobj: {}


        };
    },
    async mounted() {
        this.head = {
            headers: {
                Authorization: "Bearer " + this.token,
                "Content-Type": "application/json",
            },
        };
         if (this.$route.name !== "visitInfo"){
            this.title = this.$t("navigations.soa")
         }
        this.studyId = store.getters.getStudyIs;
        await this.getVlists();
        // await this.getStudyArms();
        window.addEventListener("studyIdChanged", async () => {
            this.studyId = store.getters.getStudyIs
            await this.getVlists();
           this.$emit("study-changed", this.studyId);
        });
    },

    methods: {
         async getStudyDetails() {
            try {
                const res = await axios.get(
                    `${this.baseurl}/management/study/getbyid?id=${this.studyId}`,
                    this.head
                );
                this.studyDetails = res.data;
                this.versiondetailsobj = res.data;
                    const currentVersion = res.data.currentVersion;
                    this.version = currentVersion;

                    const versionObj = res.data.versions.find(
                        v => v.version === currentVersion
                    );

                    this.isArmSpecific = versionObj ? versionObj.isArmSpecific : false;
                     this.routpage();
            } catch (err) {
                console.log("error in get study", err);
            }
        },
        async getVlists() {
            this.loading = true;
            this.visitList = [];
            try {
                const response = await axios.get(
                    `${this.baseapi}/management/visit/listvisit?StudyId=${this.studyId}&StudyVersion=${this.version}&ArmCode=${this.selectedArm}&SortProperty=visitNo&ConvertToNumeric=true`, this.head
                );
                console.log("Visit Activity Orders Response:", response.data);
                this.visitList = response.data.results;
                this.visitList.forEach(visit => {
                    this.activityList[visit.visitId] = [];
                });
                this.showVisitPopup = this.visitList.map(() => false);
                this.visitExpanded = this.visitList.map(() => false);

                this.loading = false;
            } catch (error) {
                console.error("Error fetching Visit Activity Orders:", error);
            }
        },
         async visitPopup(visitIdEdit, id) {
      if (id) {
        document.getElementById(id).style.display = "none"
      }
      this.showSiteModal = true
      this.visitId = visitIdEdit
    },
    async closeModal() {
      this.showSiteModal = false;
      await this.getVlists();
    },
        async getActivities(visitId, vIndex) {
            let openedActivity = {
                "visitId": visitId,
                "index": vIndex
            }
            const existingIndex = this.openedVisitArray.findIndex(
                item => item.visitId === visitId && item.index === vIndex
            );

            if (existingIndex !== -1) {
                this.openedVisitArray.splice(existingIndex, 1);
            } else {
                this.openedVisitArray.push(openedActivity);
            }

            try {
                const response = await axios.get(
                    `${this.baseapi}/management/visit/listvisitactivity?visitId=${visitId}`, this.head
                );
                let data = response.data.entities || [];
                await data.forEach(visitData => {
                    this.formList[visitData.activityId] = [];
                });
                this.activityList[visitId][vIndex] = data;
            } catch (error) {
                console.error("Error fetching Activities for VisitId " + visitId + ":", error);
            }
        },
        async getActivityForms(activityId, aIndex) {
            try {
                const response = await axios.get(
                    `${this.baseapi}/management/study/getsoa?Id=${activityId}`, this.head
                );
                console.log("SOA Response:", response.data);
                this.formList[activityId][aIndex] = response.data.eCRF;
                console.log("Form List:", this.formList);
            } catch (error) {
                console.error("Error fetching SOA:", error);
            }
        },
        async viewForms(tempId) {
            this.formActivityId = tempId;
            this.setshowActivityFormModal = true;
        },
        closeformActivityModal() {
            this.setshowActivityFormModal = false;
        },
        async getStudyArms() {
            try {
                const response = await axios.get(
                    `${this.baseapi}/fhir-service/arm/getarmsbystudyid?study_id=${this.studyId}`, this.head
                );
                console.log("Study Arms Response:", response.data);
                this.armList = response.data;
            }
            catch (error) {
                console.error("Error fetching Study Arms:", error);
            }
        },
        toggleVisitMenu(index) {
 
            this.showVisitPopup = this.showVisitPopup.map(() => false);

            this.showVisitPopup[index] = true;

        },
        async deleteVisit(id) {
             this.closePopover();
            if (confirm(this.$t('navigations.are you sure you want to delete this visit?'))) {
                try {
                    await axios.delete(
                        `${this.baseapi}/management/visit/delete?id=${id}`,
                        this.head
                    );

                    alert(this.$t("navigations.visit deleted successfully"));
                    this.getVlists();
                } catch (err) {
                    alert(this.$t("navigations.failed due to internal error"));
                    console.error(err);
                }
            }

            this.showVisitPopup = this.showVisitPopup.map(() => false);
        },
        visitPopup(visitId) {
             this.closePopover(`visit-popup-${visitId}`);
            this.showVisitPopup = this.showVisitPopup.map(() => false);
            this.showSiteModal = true;
            this.visitId = visitId;
        },
        openVisitActivityModal(visitId) {
             this.closeAllPopovers();
            this.SelectedVisitId = visitId;
            this.showActivityModal = true;
        },
        async closeModal() {
            this.showSiteModal = false;
            await this.getStudyDetails();
            await this.getVlists();
        },

        toggleVisit(vIndex, visitId) {
            this.visitExpanded[vIndex] = !this.visitExpanded[vIndex];

            if (this.visitExpanded[vIndex]) {
                this.getActivities(visitId, vIndex);
            }
        },
         closePopover(popoverId) {
            const popover = document.getElementById(popoverId);
            if (popover && typeof popover.hidePopover === 'function') {
                popover.hidePopover();
            }
        },

     closeAllPopovers() {
    this.armList.forEach(arm => {
        this.closePopover(`arm-popup-${arm.ArmCode}`);
    });
    this.visitList.forEach(visit => {
        if (visit && visit.visitId) {
            this.closePopover(`visit-popup-${visit.visitId}`);
        }
    });
},
closeActivityModal() {
            this.showActivityModal = false;
            this.getVlists();
        }
    }
};